import { useState } from 'react';
import { FiPlay } from 'react-icons/fi';

const CompanyVideo = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoId = 'QteyDfg3usY';

  return (
    <section className="company-video section" id="company-video">
      <div className="container">
        <div className="company-video-header">
          <span className="section-subtitle">Company Profile</span>
          <h2 className="section-title">
            Kenali Lebih Dekat <span className="title-accent">Shuanghui Power</span>
          </h2>
          <p className="section-description company-video-desc">
            Pelajari lebih lanjut tentang fasilitas, kapabilitas produksi, dan komitmen
            kami dalam menyediakan solusi kelistrikan berkualitas tinggi.
          </p>
        </div>

        <div className="company-video-wrapper">
          {!isPlaying ? (
            <div className="company-video-thumbnail" onClick={() => setIsPlaying(true)}>
              <img
                src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
                alt="Shuanghui Power Company Profile Video"
                className="company-video-thumb-img"
              />
              <div className="company-video-overlay">
                <button className="company-video-play-btn" aria-label="Play video">
                  <FiPlay />
                </button>
                <span className="company-video-play-text">Tonton Video</span>
              </div>
            </div>
          ) : (
            <div className="company-video-iframe-wrapper">
              <iframe
                src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
                title="Shuanghui Power Company Profile"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default CompanyVideo;
